module.exports = __webpack_public_path__ + "img/banner_fh.00bab67b.jpg";